import localforage from 'localforage'

let localforageStoreSignatures = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'signatures'
})

const initialState = {
  id: null,
  dataUrl: ''
}

let state = initialState

const getters = {
  getSignature: function () {
    return state
  }
}

const actions = {
  loadSignature ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      localforageStoreSignatures.getItem(String('survey-' + surveyId)).then((value) => {
        commit('receiveSignature', {
          id: surveyId,
          data: value
        })
        resolve()
      })
    })
  },
  saveSignature ({ commit }, signature) {
    return new Promise((resolve, reject) => {
      localforageStoreSignatures.setItem(String('survey-' + signature.id), signature.dataUrl).then((value) => {
        commit('setSignatureToState', signature)
        resolve()
      })
    })
  },
  deleteSignature ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      localforageStoreSignatures.removeItem(String('survey-' + surveyId)).then(() => {
        commit('deleteSignatureFromState')
        resolve()
      })
    })
  },
  clearSignaturesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreSignatures.clear().then(() => {
        commit('clearSignaturesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  receiveSignature (state, signature) {
    state.id = signature.id
    state.dataUrl = signature.data
  },
  setSignatureToState (state, signature) {
    state.id = signature.id
    state.dataUrl = signature.data
  },
  deleteSignatureFromState (state) {
    state.dataUrl = ''
  },
  clearSignaturesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/signatures.js